import client from '../../client'

const tokenConfig = (token) => ({
  headers: {
    Authorization: `Bearer ${token}`
  }
})

export function reqGetUserPersonalData(token) {
  return client().get(`/api/users/my-personal-information`,
    tokenConfig(token))
}

export function reqUpdateUser(userInfo, token) {
  return client().put('/api/users/my-personal-information', userInfo, tokenConfig(token))
}

export function reqGetUser(token) {
  return client().get('/api/users/basic-information',
    tokenConfig(token))
}

export function reqGetUserFilesToSign(token) {
  return client().get('/api/documents-to-sign/',
    tokenConfig(token))
}

export function reqUserHasSolicitudCredito(token) {
  return client().get('/api/users/has-solicitud', tokenConfig(token))
}

export function reqGetUserVigente(token, rut) {

  // console.log(token);
  // console.log('Rut reqGetVigentes', rut);

  const rutSinDV = rut.split('-');
  // console.log('Rut sin DV', rutSinDV[0]);
  return client().get(`/api/apoyo-afiliaciones/vigentes/${rutSinDV[0]}`,
    tokenConfig(token));

}
